<template>
  <div class="pt-2">
    <h3 class="mt-2 pt-4 text-left">{{$t('NotificationChannels.accessi_notifiche')}}</h3>

    <p class="text-left">
      {{$t('NotificationChannels.descrizione_accessi')}}
    </p>

    <b-row class="">
      <b-col class="col-12 col-md-6 pl-3 shadowedCard">
        <!-- <h6 class="text-left fw-bolder px-3">Canale Mail e Push</h6> -->
        <div class="py-2 px-1 mt-3">
          <h6 class="text-left fw-bolder">{{$t('NotificationChannels.notifiche_email1')}}</h6>
          <b-col class="px-0">
            <p class="text-left mb-0">
              <template v-if="user.canale_notifica_email_consense">
                <b-icon icon="check-circle-fill" variant="success"></b-icon>
                {{$t('NotificationChannels.consenso_email')}}
                <a
                  target="_blank"
                  class="text-underlined point"
                  :href="
                    user.type == 1
                      ? privacyPolicyLinks.operatore
                      : privacyPolicyLinks.paziente
                  "
                >
                  <u>{{$t('NotificationChannels.informativa_privacy')}}</u></a
                >
              </template>
              <template v-else>
                <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                {{$t('NotificationChannels.no_consenso_email')}}
                <a
                  target="_blank"
                  class="text-underlined point"
                  :href="
                    user.type == 1
                      ? privacyPolicyLinks.operatore
                      : privacyPolicyLinks.paziente
                  "
                >
                  <u>{{$t('NotificationChannels.informativa_privacy')}}</u></a
                >
              </template>
              <b-button
                size="sm"
                class="ml-2"
                @click="$bvModal.show('email-consense-modal')"
                >{{$t('NotificationChannels.modifica')}}</b-button
              >
            </p>
          </b-col>
          <b-row cols="1" class="text-left pb-2">
            <b-col
              class="my-2 col-12 px-0"
              v-if="user.canale_notifica_email_consense"
            >
              <b-form-checkbox
                @change="editUserConsense(false)"
                v-model="mailEnabled"
                name="mail-active"
                :value="true"
                switch
              >
                {{$t('NotificationChannels.ricezione_notifiche')}}
                {{ mailEnabled == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
              </b-form-checkbox>
            </b-col>
            <h6 class="text-left fw-bolder mt-3">{{$t('NotificationChannels.notifiche_push')}}</h6>
            <b-col class="my-2 col-12 px-0" v-if="user.push_token">
              <b-form-checkbox
                @change="editUserConsense(true)"
                v-model="pushEnabled"
                name="mail-active"
                :value="true"
                switch
              >
                {{$t('NotificationChannels.ricezione_notifiche')}}
                {{ pushEnabled == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
              </b-form-checkbox>
            </b-col>
            <b-col class="my-2 px-0" v-else>
              {{$t('NotificationChannels.consent_push')}}
            </b-col>
          </b-row>
        </div>
      </b-col>
      <template v-if="bots">
        <b-col class="col-12 col-md-6 mt-4 pl-3">
          <h6 class="text-left fw-bolder px-3">{{$t('NotificationChannels.canale_telegram')}}</h6>
          <b-row class="text-left">
            <b-col
              v-for="(bot, ind) in bots['']"
              :key="'tg' + ind"
              class="my-2 col-12 px-0"
            >
              <b-form-group class="p-4">
                <label for="">Username: {{ bot.bot_username }}</label>
                <b-form-checkbox
                  @change="showModalConfirm(bot, false)"
                  v-model="bot.active"
                  :name="ind + 'active'"
                  :value="1"
                  switch
                >
                  {{$t('NotificationChannels.ricezione_notifiche')}}
                  {{ bot.active == true ? $t('NotificationChannels.attiva') : $t('NotificationChannels.disattivata') }}
                </b-form-checkbox>
                <b-button
                  class="text-center mx-auto my-2"
                  variant="outline-secondary "
                  size="sm"
                  @click="showModalConfirm(bot, true)"
                >
                  <span>
                    <b-icon icon="trash" class="ml-1 mr-2"></b-icon> {{$t('NotificationChannels.rimuovi_accesso')}}
                  </span>
                </b-button>
              </b-form-group>
            </b-col>
            <b-col v-if="!bots[''] || bots[''].length < 1" class="col-12 px-0">
              <b-form-group class="my-2 p-4">
                <label for="">{{$t('NotificationChannels.nessun_accesso')}}</label><br />
                <a
                  :href="tgLink"
                  target="_blank"
                  class="fw-bolder text-prim-grad-1 d-flex align-items-center"
                >
                  <b-iconstack font-scale="1.5" class="mr-2">
                    <b-icon
                      stacked
                      icon="reply-fill"
                      scale="0.7"
                      shift-v="0.5"
                      shift-h="0.5"
                      variant="secondary"
                    >
                    </b-icon>
                    <b-icon stacked icon="circle" variant="secondary"></b-icon>
                  </b-iconstack>
                  <span>{{$t('NotificationChannels.accedi_telegram')}}</span>
                </a>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col class="col-12 col-md-4 mt-4 pl-3">
          <h6 class="text-left fw-bolder px-3">Canale Whastapp</h6>
          <b-row class="text-left">
            <b-col v-for="(bot, ind) in bots['WB']" :key="'wa' + ind" class="my-2 col-12 px-0">
              <b-form-group class="shadowedCard p-4">
                <label for="">Numero: {{ bot.bot_username }}</label>
                <b-form-checkbox @change="showModalConfirm(bot, false)" v-model="bot.active" :name="ind + 'active'"
                  :value="1" switch>
                  Ricezione notifiche
                  {{ bot.active == true ? "attiva" : "disattivata" }}
                </b-form-checkbox>
                <b-button class="text-center mx-auto my-2" variant="outline-secondary" size="sm"
                  @click="showModalConfirm(bot, true)">
                  <span>
                    <b-icon icon="x-circle" class="ml-1 mr-2"></b-icon> Rimuovi
                    questo accesso
                  </span>
                </b-button>
              </b-form-group>
            </b-col>
            <b-col v-if="!bots['WB'] || bots['WB'].length < 1" class="col-12 px-0">
              <b-form-group class="my-2 shadowedCard p-4">
                <label for="">Nessun accesso WhatsApp attivo</label><br />
                <a :href="waLink" target="_blank" class="fw-bolder text-prim-grad-1 d-flex align-items-center">
                  <b-iconstack font-scale="1.5" class="mr-2">
                    <b-icon stacked icon="reply-fill" scale="0.7" shift-v="0.5" shift-h="0.5" variant="secondary">
                    </b-icon>
                    <b-icon stacked icon="circle" variant="secondary"></b-icon>
                  </b-iconstack>
                  <span>Accedi su WhatsApp!</span>
                </a>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col> -->
      </template>
    </b-row>
    <b-modal
      id="delete-access"
      :title="$t('NotificationChannels.elimina_accesso')"
      @cancel="resetDelete"
      @hidden="fetchData"
      @ok="handleOkDelete"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
    >
      <template v-if="selectedBot">
        <h6>
          {{$t('NotificationChannels.vuoi_rimuovere')}} 
          {{ selectedBot.messenger == "WP" ? "whatsapp" : "telegram" }} {{$t('NotificationChannels.accesso_da')}}
          {{ selectedBot.bot_username }} ?
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="update-access"
      :title="$t('NotificationChannels.modifica_stato')"
      @cancel="resetUpdate"
      @hidden="fetchData"
      @ok="handleOkUpdate"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
    >
      <template v-if="selectedBot">
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ selectedBot.active == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_messenger')}} {{ selectedBot.messenger == "WP" ? "whatsapp" : "telegram" }}
          {{$t('NotificationChannels.da')}}
          {{ selectedBot.bot_username }}?
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="update-consenses"
      :title="$t('NotificationChannels.conferma_operazione')"
      @cancel="cancelUpdateConsense"
      @ok="updateConsense"
      button-size="sm"
      :cancel-title="$t('NotificationChannels.annulla')"
      cancel-variant="popup-button mr-2"
      :ok-title="$t('NotificationChannels.conferma')"
      ok-variant="popup-button"
      footer-class="border-0"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-if="pushMessageAlert">
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ pushEnabled == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_push')}}
        </h6>
      </template>
      <template v-else>
        <h6>
          {{$t('NotificationChannels.vuoi')}} {{ mailEnabled == true ? $t('NotificationChannels.attivare') : $t('NotificationChannels.disattivare') }}
          {{$t('NotificationChannels.notifiche_email')}}
        </h6>
      </template>
    </b-modal>
    <b-modal
      id="email-consense-modal"
      :title="$t('NotificationChannels.consenso_email_title')"
      centered
      hide-footer
    >
      <b-form-group>
        <b-form-radio-group v-model="emailConsense" name="email_options">
          <b-form-radio :value="true">
            {{$t('NotificationChannels.acconsento_email')}}
            <a
              target="_blank"
              class="text-underlined point"
              :href="
                user.type == 1
                  ? privacyPolicyLinks.operatore
                  : privacyPolicyLinks.paziente
              "
            >
              <u>{{$t('NotificationChannels.informativa_privacy')}}</u>
            </a>
          </b-form-radio>
          <b-form-radio :value="false" class="mt-3"> {{$t('NotificationChannels.non_accetto')}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <div class="d-flex justify-content-end mt-4">
        <b-button
          class="mr-2 btn-popup-button"
          @click="$bvModal.hide('email-consense-modal')"
        >
          {{$t('NotificationChannels.annulla')}}
        </b-button>
        <b-button class="btn-popup-button" @click="updateConsense">
          {{$t('NotificationChannels.salva_modifiche')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { cittadinoService } from "@/_services";
export default {
  name: "NotificationChannels",
  data() {
    return {
      bots: null,
      mock: {
        bot_username: null,
        active: false,
        deleted_at: true,
      },
      selectedBot: null,
      pushMessageAlert: false,
      pushEnabled: false,
      mailEnabled: false,
      waLink: "https://wa.me/" + process.env.VUE_APP_WA_CHANNEL,
      tgLink: "https://t.me/" + process.env.VUE_APP_TG_CHANNEL,
      emailConsense: false,
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE,
      },
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    fetchData() {
      var self = this;
      cittadinoService
        .getUserBots()
        .then(function (res) {
          // console.log(res);
          self.bots = res.data.data;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('NotificationChannels.errore_accessi'))

        });
    },
    showModalConfirm(bot, doDelete) {
      this.selectedBot = bot;
      if (doDelete) {
        this.$bvModal.show("delete-access");
      } else {
        this.$bvModal.show("update-access");
      }
    },
    editUserConsense(push) {
      this.pushMessageAlert = push;
      this.$bvModal.show("update-consenses");
    },
    resetDelete() {
      this.selectedBot = null;
      this.$bvModal.hide("delete-access");
    },
    resetUpdate() {
      this.selectedBot = null;
      this.$bvModal.hide("update-access");
    },
    cancelUpdateConsense() {
      if (this.pushMessageAlert) {
        this.pushEnabled = !this.pushEnabled;
      } else {
        this.mailEnabled = !this.mailEnabled;
      }
    },
    handleOkDelete() {
      var self = this;
      cittadinoService
        .deleteBotAccess(this.selectedBot.hashid)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("delete-access");
          self.successAlert(self.$t('NotificationChannels.accesso_eliminato'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          self.$bvModal.hide("delete-access");
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('NotificationChannels.errore_eliminazione'))
        });
    },
    handleOkUpdate() {
      var self = this;
      var form = {
        active: this.selectedBot.active,
      };
      cittadinoService
        .updateUserBots(form, this.selectedBot.hashid)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.successAlert(self.$t('NotificationChannels.modifiche_successo'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.errorAlert(self.$t('NotificationChannels.errore_modifiche'))
          self.selectedBot = null;
        });
    },
    updateConsense() {
      var self = this;
      var form = {
        push_consense: this.pushEnabled,
        notification_consense: this.mailEnabled,
        canale_notifica_email_consense: this.emailConsense,
      };
      cittadinoService
        .updateConsense(form)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.$bvModal.hide("email-consense-modal");
          self.user.canale_notifica_email_consense = self.emailConsense;
          self.successAlert(self.$t('NotificationChannels.modifiche_successo'))
          self.selectedBot = null;
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.$bvModal.hide("update-access");
          self.errorAlert(self.$t('NotificationChannels.errore_modifiche'))
          self.selectedBot = null;
        });
    },
  },
  watch: {
    emailConsense(newVal) {
      this.mailEnabled = newVal;
    },
  },
  created() {
    //TEMPORANEAMENTE DISATTIVATO
    // this.fetchData();
  },
  mounted() {
    this.pushEnabled = this.user.push_consense == true;
    this.mailEnabled = this.user.notification_consense == true;
    this.emailConsense = this.user.canale_notifica_email_consense == true;
  },
};
</script>
